import React, { useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';

const MenuDesplegable = ({ opciones, onOpcionSeleccionada }) => {
  const [menuVisible, setMenuVisible] = useState(false);
  const menuRef = useRef(null);

  const toggleMenu = () => {
    setMenuVisible(!menuVisible);
  };

  const handleOpcionSeleccionada = (opcion) => {
    toggleMenu();
    onOpcionSeleccionada(opcion);
  };

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setMenuVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []); // Se ejecuta solo al montar y desmontar el componente

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <button
        style={{
          background: '#545b62',
          color: '#fff',
          border: 'none',
          padding: '5px',
          borderRadius: '5px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
        }}
        onClick={toggleMenu}
        type="button"
      >
        Copiar de: &nbsp;&nbsp;
        <FontAwesomeIcon icon={faBars} style={{ marginRight: '1px' }} />
      </button>
      {menuVisible && (
        <div
          ref={menuRef}
          style={{
            position: 'absolute',
            bottom: '100%', // Coloca el menú arriba del botón
            right: '0',
            background: '#fff',
            boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
            padding: '10px',
            borderRadius: '5px',
            zIndex: 1,
            width: '200px',
            transition: 'background-color 0.3s',
          }}
          onMouseEnter={() => {
            // menuRef.current.style.backgroundColor = '#e6e6e6';
            menuRef.current.querySelectorAll('div').forEach((option) => (option.style.color = '#000'));
          }}
          onMouseLeave={() => {
            menuRef.current.style.backgroundColor = '#fff';
            menuRef.current.querySelectorAll('div').forEach((option) => (option.style.color = '#000')); // Cambiado a color original del texto
          }}
        >
          {opciones.map((opcion, index) => (
            <div
              key={index}
              onClick={() => handleOpcionSeleccionada(opcion)}
              style={{
                cursor: 'pointer',
                marginBottom: '5px',
                transition: 'background-color 0.3s',
                /* Estilo condicional para hover */
                ':hover': {
                  backgroundColor: '#f0f0f0', // Cambiar el color al pasar el cursor
                },
              }}
              onMouseEnter={(e) => (e.target.style.backgroundColor = '#e6e6e6')} // Cambiar el color al pasar el cursor
              onMouseLeave={(e) => (e.target.style.backgroundColor = 'transparent')} // Cambiar el color de nuevo al salir el cursor
            >
              {opcion}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MenuDesplegable;
